/** @format */


import axios from "axios";


const getToken = () =>
  document.cookie
    .split("; ")
    .find((row) => row.startsWith("accessToken="))
    ?.split("=")[1];

// Helper function to get the auth headers
const getAuthHeaders = () => {
  const token = getToken();
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};

export async function signIn(username, password) {
  console.log("env print", process.env.REACT_APP_BACKEND_URL)
  try {
    // No token is added here, as signIn is used to obtain the token.
    const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/Users/signIn`, {
      username,
      password,
    });
    console.log("response", response);
    return response;
  } catch (error) {
    throw error;
  }
}

// signIn function
// export const signIn_1 = (username, password) => async (dispatch) => {
//   dispatch(signInStart());   try {
//     axios.defaults.withCredentials = true; 
//     const response = await axios.post(`${API}/signin`, {
//       username,
//       password,
//     });

//     const data = response.data || {}; 
//     dispatch(
//       signInSuccess({
//         user: data.user || {}, 
//         token: data.token || "", 
//       })
//     );

//     return data; 
//   } catch (error) {
//     const errorMessage = error.response?.data?.message || "Sign-in failed"; 
//     dispatch(signInFailure(errorMessage)); 
//     throw new Error(errorMessage); 
//   }
// };





// function for signOut
// export async function signOut() {
//   axios.defaults.withCredentials = true;
//   try {
//     // This function would typically require a token for authentication to log out the specific user
//     const response = await axios.post(
//       `${process.env.REACT_APP_BACKEND_URL}/Users/signout`,
//       {}, // POST requests with no body still take a data argument
//       getAuthHeaders() // Added authentication headers
//     );
//     return response;
//   } catch (error) {
//     throw error;
//   }
// }


// function for forgot password
// export async function forgotPassword(email) {
//   axios.defaults.withCredentials = true;
//   try {
//     // Forgot password typically doesn't require a token
//     const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/Users/forgot-password`, {
//       username: email,
//     });
//     return response;
//   } catch (error) {
//     throw error;
//   }
// }


// function for reset password
// export async function resetPassword(token, password) {
//   axios.defaults.withCredentials = true;
//   try {
//     // Reset password usually uses the reset token from the URL, not an accessToken
//     const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/Users/reset-password/${token}`, {
//       password,
//     });
//     return response;
//   } catch (error) {
//     throw error;
//   }
// }


export async function forgotPwd(email) {
  console.log("env print", process.env.REACT_APP_BACKEND_URL)
  try {
    // If your backend *does* require a token for this endpoint (uncommon for forgot password),
    // you would add getAuthHeaders() here.
    const response = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/v1/Users/forgotPassword`,
      { email },
      getAuthHeaders() // Added authentication headers
    );
    console.log("response", response);
    return response;
  } catch (error) {
    throw error;
  }
}